'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'face-zipper';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e3a5';
var svgPathData = ['M32 256C32 132.3 132.3 32 256 32S480 132.3 480 256c0 8.4-.5 16.7-1.4 24.8l27.9 27.9c-4.3 20.7-11.2 40.5-20.2 59L438.6 320c-12.5-12.5-32.8-12.5-45.3 0L352 361.4c-12.5 12.5-12.5 32.8 0 45.3l52.7 52.7c1 1 2 2 3.1 2.9-15.6 11.5-32.5 21.2-50.4 29l-24.6-24.6C308.8 475.2 282.9 480 256 480 132.3 480 32 379.7 32 256zm112 64l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm8-112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm56 112l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 0l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm40-112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z', 'M256 480c26.9 0 52.8-4.8 76.7-13.5l24.6 24.6C326.3 504.6 292 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0 512 114.6 512 256c0 18.1-1.9 35.7-5.4 52.7l-27.9-27.9c.9-8.1 1.4-16.4 1.4-24.8 0-123.7-100.3-224-224-224S32 132.3 32 256 132.3 480 256 480zM224 304c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zm80 16l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16zM160 304c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zm16-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM438.6 320l52.7 52.7c23.9 23.9 23.9 62.7 0 86.6s-62.7 23.9-86.6 0L352 406.6c-12.5-12.5-12.5-32.8 0-45.3L393.4 320c12.5-12.5 32.8-12.5 45.3 0zm-64 64l52.7 52.7c11.4 11.4 29.9 11.4 41.4 0s11.4-29.9 0-41.4L416 342.6 374.6 384z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceZipper = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;